/**
 * Resolve a display URL from a team's fansbury_image payload ({ small, medium, big }).
 */
export const teamImageUrl = (team, size = "medium") => {
  const image = team?.fansbury_image ?? team?.image;
  if (!image) return null;
  if (typeof image === "string") return image;
  return (
    image[`team_${size}`] ||
    image[size] ||
    image.team_medium ||
    image.medium ||
    image.team_small ||
    image.small ||
    image.team_big ||
    image.big ||
    Object.values(image).find(Boolean) ||
    null
  );
};
